import "./Coverage.css";
// import coverageLight from "../../../assets/svg/Coverage-img-light-original.png";
// import coverageDark from "../../../assets/svg/Coverage-img-original.png";

import {ReactComponent as CoverageLight} from "../../../assets/svg/Coverage-img-original-lght.svg";
import {ReactComponent as CoverageDark} from "../../../assets/svg/Coverage-img-original-drk.svg";
// Копії з суфіксом _mobile в id (pattern/clip-path/image): обидві версії мапи
// одночасно в DOM, і з однаковими id url(#...) резолвився б на десктопну
// копію, приховану display:none, — прапори на мобайлі зникали.
import {ReactComponent as CoverageLightMobile} from "../../../assets/svg/Coverage-img-original-lght-mobile.svg";
import {ReactComponent as CoverageDarkMobile} from "../../../assets/svg/Coverage-img-original-drk-mobile.svg";

import {useTheme} from "../../../hooks/useTheme";
import CustomScroll from "./CustomScroll";


export default function Hero() {
  const {theme} = useTheme();
  const isDark = theme === "dark";


  return (
    <section className="coverage">
      <div className="coverage-left">
        <h1 className="coverage-title">Coverage</h1>
        <p className="coverage-subtitle">We are working in all below mentioned countries:</p>
      </div>

      <div className="coverage-right">
        {
          isDark ? <CoverageDark className="coverage-map"
                                 alt="Coverage map"/>
            :
            <CoverageLight className="coverage-map"
                           alt="Coverage map"/>
        }
        {/*<img*/}
        {/*  src={isDark ? coverageDark : coverageLight}*/}
        {/*  alt="Coverage map"*/}
        {/*  className="coverage-map"*/}
        {/*/>*/}
      </div>

      <div className="mobile-coverage-interactive">
        <CustomScroll>
          {
            isDark ? <CoverageDarkMobile className="coverage-map"
                                         alt="Coverage map"/>
              :
              <CoverageLightMobile className="coverage-map"
                                   alt="Coverage map"/>
          }
          {/*<img src={isDark ? coverageDark : coverageLight} className="coverage-map" alt="Coverage map"/>*/}
        </CustomScroll>
      </div>
    </section>

  );
}
